import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import styles from './Services.module.css';
import localRideImage from '../../assets/local-ride.jpeg';
import outstationImage from '../../assets/outstation.jpeg';
import airportImage from '../../assets/airport.jpeg';
import corporateImage from '../../assets/corporate.jpeg';

const services = [
  {
    title: 'Local Rides',
    description: 'Book cabs for daily commutes and short distances within the city.',
    image: localRideImage,
  },
  {
    title: 'Outstation Trips',
    description: 'Plan a comfortable outstation journey with our reliable cab service.',
    image: outstationImage,
  },
  {
    title: 'Airport Transfers',
    description: 'Hassle-free airport pickups and drop-offs, on time every time.',
    image: airportImage,
  },
  {
    title: 'Corporate Travel',
    description: 'Professional cab solutions for corporate employees and business travel.',
    image: corporateImage,
  },
];

const Services = () => {
  return (
    <div className={styles.servicesPage}>
      <Container className="py-5">
        <h2 className="text-center mb-5">Our Services</h2>
        <Row>
          {services.map((service, idx) => (
            <Col md={6} lg={3} key={idx} className="mb-4">
              <Card className={styles.serviceCard}>
                <Card.Img variant="top" src={service.image} />
                <Card.Body>
                  <Card.Title>{service.title}</Card.Title>
                  <Card.Text>{service.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Services;